export const EDITOR_SUCCESS = "EDITOR_SUCCESS";

export const MEETING_LINK_SUCCESS = "MEETING_LINK_SUCCESS";
export const MEETING_LINK_REQUEST = "MEETING_LINK_REQUEST";
export const MEETING_LINK_FAIL = "MEETING_LINK_FAIL";
